import { ErrorHandler, Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class GlobalAppErrorHandler implements ErrorHandler {
  constructor(
    private router: Router,
    private zone: NgZone,
  ) {}

  handleError(error: unknown): void {
    // Cypress: surface real failures
    if (typeof window !== "undefined") {
      const w = window as typeof window & { Cypress?: unknown };
      if (w.Cypress) {
        throw error;
      }
    }

    const message = this.getMessage(error);

    // If you're still chasing the MatFormField crash, keep this block;
    // otherwise remove it later once resolved.
    if (
      message.includes("controlType") ||
      message.includes("errorState") ||
      message.toLowerCase().includes("matformfieldcontrol") ||
      message.toLowerCase().includes("mat-form-field")
    ) {
      this.dumpMatFormFieldDiagnostics(message);
    }

    console.error("Global error:", error);

    if (message.includes("AADSTS")) {
      this.zone.run(() => this.router.navigate(["/no-access"]));
    }
  }

  private getMessage(error: unknown): string {
    if (typeof error === "string") return error;

    if (error && typeof error === "object") {
      const e = error as { message?: unknown; toString?: unknown };
      if (typeof e.message === "string") return e.message;
      if (typeof e.toString === "function") return String(e.toString());
    }

    try {
      return String(error);
    } catch {
      return "";
    }
  }

  private dumpMatFormFieldDiagnostics(triggerMessage: string): void {
    try {
      const fields = Array.from(document.querySelectorAll("mat-form-field"));

      console.group("MatFormField diagnostics");
      console.log("Trigger:", triggerMessage);
      console.log("mat-form-field count:", fields.length);

      const controlSelector =
        "input[matinput],textarea[matinput],mat-select,mat-chip-grid,mat-chip-list,mat-chip-listbox";

      fields.slice(0, 50).forEach((ff, i) => {
        const ctl = ff.querySelector(controlSelector) as Element | null;
        const ffSnippet = ff.outerHTML.slice(0, 320);

        console.log(
          "FF",
          i,
          "control:",
          ctl ? ctl.tagName.toLowerCase() : "none",
          "ff:",
          ffSnippet,
        );

        if (!ctl) {
          console.warn("FF missing control:", i, ffSnippet);
        }
      });

      console.groupEnd();
    } catch (e) {
      console.warn("MatFormField diagnostics failed:", e);
    }
  }
}
